export const usePermissions = (moduleName: string) => {
  // Get userDetails from localStorage
  const storedUser = localStorage.getItem("userDetails");
  const parsedUser = storedUser ? JSON.parse(storedUser) : null;

  // Extract permissions from userDetails
  const permissions = parsedUser?.permissions || {
    Initiatives: { read: 0, write: 0, edit: 0, delete: 0 },
    "Key results": { read: 0, write: 0, edit: 0, delete: 0 },
    Milestone: { read: 0, write: 0, edit: 0, delete: 0 },
    Objectives: { read: 0, write: 0, edit: 0, delete: 0 },
    "Role Management": { read: 0, write: 0, edit: 0, delete: 0 },
  };

  // Get module-specific permissions
  const modulePermissions = permissions[moduleName] || {
    read: 0,
    write: 0,
    edit: 0,
    delete: 0,
  };

  return {
    canRead: modulePermissions.read === 1,
    canWrite: modulePermissions.write === 1,
    canEdit: modulePermissions.edit === 1,
    canDelete: modulePermissions.delete === 1,
  };
};
